/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeTriangleUpIcon64Regular = forwardRef('ShapeTriangleUpIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.63 9.41c2.934-4.722 9.806-4.722 12.74 0l21.208 34.132C62.683 48.538 59.09 55 53.208 55H10.792c-5.882 0-9.475-6.462-6.37-11.458L25.63 9.41Zm10.192 1.584c-1.76-2.834-5.884-2.834-7.644 0L6.97 45.125C5.107 48.123 7.263 52 10.792 52h42.416c3.53 0 5.685-3.877 3.822-6.875L35.822 10.994Z" })));
});
